import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Route, Switch, Redirect } from 'react-router-dom';

import BasicFoodSearch from '../components/search/basicFood/BasicFoodSearch';
import SingleNutrientSearch from '../components/search/singleNutrient/SingleNutrientSearch';
import MultiFoodSearch from '../components/search/multiFood/MultiFoodSearch';
import MultiNutrientSearch from '../components/search/multiNutrient/MultiNutrientSearch';

class SearchPage extends Component {
  render() {
    const { path, url } = this.props.match;

    return (
      <div className="SearchPage container">
        <Helmet title="New Zealand Food Composition Database" />
        
        <Switch>
          <Route path={`${path}/food`} component={BasicFoodSearch} />
          <Route path={`${path}/nutrient`} component={SingleNutrientSearch} />
          <Route path={`${path}/multifood`} component={MultiFoodSearch} />
          <Route path={`${path}/multinutrient`} component={MultiNutrientSearch} />
          <Route render={() => (
            <Redirect to={`${url}/food`} />
          )} />
        </Switch>
      </div>
    );
  }
}

SearchPage.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
};

export default SearchPage;



// WEBPACK FOOTER //
// ./src/views/search.js